import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<{}> {

    static about = `
This is a sample handler to facilitate responding to a 'More Info' button click.

Define a command to put the event on the bus:

    <COMMAND id="more-info" mid="app/commands/trigger" text="More Property Information" type="action">
    <OPTIONS>
        <Values id="event" value="more-info" />
    </OPTIONS>
    </COMMAND>

Now define a handler to listen to that event:

    <EVENT 
        about="Test features contain more-info commands, this just opens a test dialog" 
        event="more-info" 
        id="more-info-handler" 
        mid="app/commands/more-info" 
        text="Show Additional Feature Information" type="point" />

    `;

    execute(args = this.args) {
        window.alert("TODO: determine what constitutes 'more info' and render it");
        this.trigger({});
    }

}

export = Command; 